import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./redux/store";
import { ConfigProvider } from "antd";

const root = ReactDOM.createRoot(document.getElementById("root"));
const themeConfig = {
  token: {
    colorPrimary: "red", // 🔥 Change primary color
    // colorText: "#ffffff",
    // colorBgBase: "#1e1e1e",
    // colorBgContainer: "white",
    borderRadius: 8,
    colorBgSolid: "red",
  },
};
root.render(
  <ConfigProvider theme={themeConfig}>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </ConfigProvider>
);
